<section
  class="row mt-2 ps-1 pt-2 pb-3 ml-2 main-content-width button_container"
  style="overflow-x: visible"
>
  @if (!isAppealReadOnly) {
  <div class="col-auto ps-lg-0">
    @if (showContinue) {
    <button
      id="continue"
      class="btn btn-block btn-secondary"
      (click)="emitContinue()"
      [disabled]="disableContinue"
    >
      {{ labelContinue | globalTranslate }}
    </button>
    }
  </div>
  } @if (isAppealReadOnly && labelContinue !== 'FILE_APPEAL') {
  <div class="col-auto">
    @if (showContinue) {
    <button
      id="continue"
      class="btn btn-block btn-secondary"
      (click)="emitContinue()"
      [disabled]="disableContinue"
    >
      {{ labelContinue | globalTranslate }}
    </button>
    }
  </div>
  } @if (((isAppeal && !isKepro) && sectionId !== 'APSUM') || (isBCCEXT) ||
  (isIME)) {
  <div class="col-auto">
    <button
      id="saveExit"
      class="btn btn-block btn-outline-secondary"
      (click)="appealCancel('exit')"
    >
      {{ labelExit | globalTranslate }}
    </button>
  </div>
  } @if (isAppeal && sectionId === 'APSUM' && !isAppealReadOnly) {
  <div class="col-auto">
    <button
      id="saveExit"
      class="btn btn-block btn-outline-secondary"
      (click)="appealCancel('cancel')"
    >
      {{ labelCancel | globalTranslate }}
    </button>
  </div>
  } @if (isAppeal && sectionId === 'APSUM' && isKepro && isAppealReadOnly) {
  <div class="col-auto">
    <button
      id="saveExit"
      class="btn btn-block btn-outline-secondary"
      (click)="appealCancel('readOnlyAplCancel')"
    >
      {{ labelCancel | globalTranslate }}
    </button>
  </div>
  } @if (isMedicalAppeal && sectionId === 'MASUM') {
  <div class="col-auto">
    <button
      id="saveExit"
      class="btn btn-block btn-outline-secondary"
      (click)="medicalAppealCancel('cancel')"
    >
      {{ labelCancel | globalTranslate }}
    </button>
  </div>
  } @if (showSaveExit && showExit) {
  <div class="col-auto">
    @if (showSaveExit && showExit) {
    <button
      id="saveExit"
      class="btn btn-block btn-outline-secondary"
      (click)="emitExit()"
      [disabled]="disableContinue"
      [ngClass]="{ 'width-translate': increaseWidth() }"
    >
      {{ "SAVE_AND_EXIT" | globalTranslate }}
    </button>
    }
  </div>
  } @if (showSubmit) {
  <div class="col-auto">
    @if (showSubmit) {
    <button
      id="submit"
      class="btn btn-block btn-primary"
      (click)="emitSubmit()"
      [disabled]="disableSubmit"
    >
      {{ "SUBMIT" | globalTranslate }}
    </button>
    }
  </div>
  }
</section>